enum TrainingUrls {
  SEARCH = '/training/search/',
}

export default TrainingUrls;
